<ng-template #trainTitle let-travelSolution="travelSolution">
  @if (travelId) {
    <span class="trip_booking_package_description">
      {{ travelSolution.description }}
    </span>
  }
  @if (!travelId) {
    <span class="trip_booking_package_description">
      {{ travelSolution.start.stationName }}
      <mat-icon style="vertical-align: middle">chevron_right</mat-icon>
      {{ travelSolution.end.stationName }}
    </span>
  }
</ng-template>

<ng-template #trainSubTitle let-travelSolution="travelSolution">
  @if (!isCarnet && travelSolution.departure) {
    <span class='font-size-14 secondary-text'>
      {{ travelSolution.departure | date: 'dd/MM/yyyy HH:mm'}} -
      {{ travelSolution.arrival| date:'HH:mm' }}
    </span>
  }
  @if (isCarnet) {
    <span class='font-size-14 secondary-text'>
      CARNET VIAGGI
    </span>
  }
</ng-template>

<div class="position-relative trip-booking-package-card-container cursor-pointer" (click)="viewProduct()">
  <div class="p-16">
    @if (dataTrain.returnTravelSolution) {
      <div class="mb-8">
        <span class="ar-title">Viaggio A/R</span>
      </div>
    }
    @if (!tripBookingPackage.parent_trip_booking_package_id) {
      <trip-booking-package-header
        icon="train"
        [showConfirm]="showHeaderActions && tripBookingStatus == 'mix'"
        [showEdit]="showHeaderActions"
        [canDelete]="showHeaderActions"
        (editClick)="editTripBookingPackage()"
        (confirmClick)="confirmTripBookingPackage()"
        (deleteClick)='deleteTripBookingPackage()'
        >
        <ng-container
          ngProjectAs="[title]"
          [ngTemplateOutlet]='trainTitle'
          [ngTemplateOutletContext]='{travelSolution:dataTrain}'>
        </ng-container>
        <ng-container
          ngProjectAs="[sub-title-1]" [ngTemplateOutlet]='trainSubTitle'
          [ngTemplateOutletContext]='{travelSolution:dataTrain}'>
        </ng-container>
        <ng-container ngProjectAs="[sub-title-2]">
          @if (status==='canceled') {
            <strong style="color:red"> CANCELLATO </strong>
          }
          @if (status==='refunded') {
            <strong style="color:red"> RIMBORSATO </strong>
          }
          @if (!status && !tripBookingPackage.tour_operator_booking_commit_status && tripBookingPackage.booking_status == 'canceled' ) {
            <strong style="color:var(--color-dark-blue)"> DA CONFERMARE </strong>
          }
        </ng-container>
        <!--TODO make actions header dinamics-->
        <!--<button mat-icon-button
        (click)='editTripBookingTravellers();$event.stopPropagation();'
        matTooltip="Modifica dati passeggeri">
        <mat-icon color='primary'>group</mat-icon>
      </button>-->
    </trip-booking-package-header>
  }

  <!--Return -->
  @if (!tripBookingPackage.parent_trip_booking_package_id && dataTrain.returnTravelSolution) {
    <trip-booking-package-header
      icon="train"
      [showConfirm]="false"
      [showEdit]="false"
      [canDelete]="false"
      [hidePrice]="true"
      (editClick)="editTripBookingPackage()"
      (confirmClick)="confirmTripBookingPackage()"
      (deleteClick)='deleteTripBookingPackage()'
      >
      <ng-container
        ngProjectAs="[title]"
        [ngTemplateOutlet]='trainTitle'
        [ngTemplateOutletContext]='{travelSolution:dataTrain.returnTravelSolution}'>
      </ng-container>
      <ng-container
        ngProjectAs="[sub-title-1]" [ngTemplateOutlet]='trainSubTitle'
        [ngTemplateOutletContext]='{travelSolution:dataTrain.returnTravelSolution}'>
      </ng-container>
      <ng-container ngProjectAs="[sub-title-2]">
        @if (status==='canceled') {
          <strong style="color:red"> CANCELLATO </strong>
        }
        @if (status==='refunded') {
          <strong style="color:red"> RIMBORSATO </strong>
        }
        @if (!status && !tripBookingPackage.tour_operator_booking_commit_status && tripBookingPackage.booking_status == 'canceled' ) {
          <strong style="color:var(--color-dark-blue)"> DA CONFERMARE </strong>
        }
      </ng-container>
      <!--TODO make actions header dinamics-->
      <!--<button mat-icon-button
      (click)='editTripBookingTravellers();$event.stopPropagation();'
      matTooltip="Modifica dati passeggeri">
      <mat-icon color='primary'>group</mat-icon>
    </button>-->
  </trip-booking-package-header>
}
@if (participantsWarning.status) {
  <div >
    <span  class="text-semibold text-color-tangerine"> Attenzione il numero dei partecipanti al viaggio sono diversi da quelli della prenotazione</span><br>
    <span>Partecipanti: {{participantsWarning.value.ADT}} ADT - {{participantsWarning.value.CHD}} RGZ</span>
  </div>
}
</div>
@if (tripBookingPackage.children_trip_booking_packages) {
  @for (children_trip_booking_package of tripBookingPackage.children_trip_booking_packages; track children_trip_booking_package) {
    <hr/>
    @if (children_trip_booking_package.parent_trip_booking_package_relation_type == 'post_sale') {
      <trip-booking-package-trenitalia-post-sale
        [tripBookingPackage]="children_trip_booking_package"
      ></trip-booking-package-trenitalia-post-sale>
    }
  }
  @if (tripBookingPackage.children_trip_booking_packages.length) {
    <hr/>
    <div class="trip-booking-package-total-row flex-row justify-between">
      <div class="flex"></div>
      <span class="font-size-14 text-color-black"
        matTooltip="{{totalFee>0?'Prezzo:'+totalRowLordo-totalFee+' € + Diritti agenzia:'+totalFee+' €':''}}"
      >Totale: {{totalRowLordo | currency:'EUR' }}</span>
    </div>
  }
}
<!-- error notification  Tour Operator Booking Data-->
@if (tripBookingPackage.tour_operator_booking_data?.status_error; as statusError) {
  <mat-card class="warn" style="margin-top: 12px;">
    <mat-card-content>
      <span>{{statusError}}</span>
    </mat-card-content>
  </mat-card>
}
</div>